import React from 'react';

import { Skeleton } from 'antd';
import { Text } from 'farmhub-ui-core';
import moment from 'moment';

import { getDummyArray } from 'utils';

import ExpandTable from '../ExpandTable';
import { CTable, WrapperAbsolute } from './styles';

type GroupProductTableProps = {
  order: any;
  isLoading: boolean;
};

const GroupProductTable = ({ order, isLoading }: GroupProductTableProps) => {
  const columns: Array<any> = [
    {
      width: '5%',
      title: (
        <Text
          color="black"
          styles={{ whiteSpace: 'nowrap' }}
          weight="extraBold"
        >
          STT
        </Text>
      ),
      key: 'order',
      align: 'center',
      render: (_: any, record: any, index: number) => {
        return {
          children: <></>,
          props: {
            className: 'hide-column-table',
          },
        };
      },
    },
    {
      width: '24%',
      title: (
        <>
          <Text color="black" weight="extraBold">
            SẢN PHẨM
          </Text>
        </>
      ),
      dataIndex: 'product',
      key: 'product',
      // colSpan: 5,
      render: (product: any, record: any) => {
        return {
          children: (
            <>
              <WrapperAbsolute>
                <Text
                  color="black"
                  lineNumber={1}
                  size="sm"
                  styles={{ width: '100%', display: 'block' }}
                  weight="bold"
                >
                  {record.name}
                </Text>
              </WrapperAbsolute>
              <Text
                color="black"
                lineNumber={1}
                size="sm"
                styles={{ whiteSpace: 'nowrap !important' }}
                weight="bold"
              >
                .
              </Text>
            </>
          ),
          props: {
            className: 'merge-column-table hide-column-table',
          },
        };
      },
    },
    {
      align: 'center',
      width: '12%',
      title: (
        <>
          <Text color="black" size="tiny" weight="extraBold">
            S.LƯỢNG
          </Text>{' '}
          <br />
          <Text color="black" weight="extraBold">
            ĐẶT
          </Text>
        </>
      ),
      dataIndex: 'customerQuantity',
      key: 'customerQuantity',
      render: (customerQuantity: number) => {
        return {
          children: <></>,
          props: {
            className: 'hide-column-table',
          },
        };
      },
    },
    {
      align: 'center',
      width: '12%',
      title: (
        <>
          <Text color="black" size="tiny" weight="extraBold">
            S.LƯỢNG
          </Text>{' '}
          <br />
          <Text color="black" weight="extraBold">
            GIAO
          </Text>
        </>
      ),
      dataIndex: 'supplierQuantity',
      key: 'supplierQuantity',
      render: (supplierQuantity: number) => {
        return {
          children: <></>,
          props: {
            className: 'hide-column-table',
          },
        };
      },
    },
    {
      align: 'center',
      width: '12%',
      title: (
        <>
          <Text color="black" size="tiny" weight="extraBold">
            S.LƯỢNG
          </Text>{' '}
          <br />
          <Text color="black" weight="extraBold">
            SƠ CHẾ
          </Text>
        </>
      ),
      dataIndex: 'customerLossQuantity',
      key: 'customerLossQuantity',
      render: (customerLossQuantity: number) => {
        return {
          children: <></>,
          props: {
            className: 'hide-column-table',
          },
        };
      },
    },
    {
      align: 'center',
      width: '12%',
      title: (
        <>
          <Text color="black" size="tiny" weight="extraBold">
            S.LƯỢNG
          </Text>{' '}
          <br />
          <Text color="black" weight="extraBold">
            NHẬN
          </Text>
        </>
      ),
      dataIndex: 'customerReceivedQuantity',
      key: 'customerReceivedQuantity',
      render: (customerReceivedQuantity: number) => {
        return {
          children: <></>,
          props: {
            className: 'hide-column-table',
          },
        };
      },
    },
    {
      width: '22%',
      title: (
        <>
          <Text color="black" weight="extraBold">
            GHI CHÚ KH
          </Text>{' '}
          <br />
          <Text color="black" weight="extraBold">
            GHI CHÚ NCC
          </Text>
        </>
      ),
      key: 'price',
      render: record => {
        return {
          children: <></>,
        };
      },
    },
  ];

  return isLoading ? (
    <></>
  ) : (
    <CTable
      bordered
      columns={isLoading ? columnsSkeleton : columns}
      dataSource={isLoading ? getDummyArray(10) : order?.entitySubCategories}
      expandable={{
        expandedRowRender: (record: any) =>
          isLoading ? (
            <></>
          ) : (
            <ExpandTable
              isLoading={isLoading}
              order={order}
              productItems={record?.orderItems ?? ''}
            />
          ),
        expandIconColumnIndex: -1,
        defaultExpandAllRows: !isLoading,
        expandRowByClick: false,
        showExpandColumn: false,
        expandIcon: null,
        indentSize: 0,
      }}
      isLoading={isLoading}
      locale={{
        emptyText: (
          <Text color="black">Hiện tại không có sản phẩm thống kê</Text>
        ),
      }}
      pagination={false}
    />
  );
};

export default GroupProductTable;

const columnsSkeleton: Array<any> = [
  {
    width: '6%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '25px', alignItems: 'center' }}
      />
    ),
    key: 'order',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '25px', alignItems: 'center' }}
      />
    ),
  },
  {
    width: '24%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '160px', alignItems: 'center' }}
      />
    ),
    key: 'product',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '160px', alignItems: 'center' }}
      />
    ),
  },
  {
    align: 'center',
    width: '12%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'customerQuantity',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
  {
    align: 'center',
    width: '12%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'supplierQuantity',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
  {
    align: 'center',
    width: '12%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'customerLossQuantity',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
  {
    align: 'center',
    width: '12%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'customerReceivedQuantity',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
  {
    width: '22%',
    title: (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
    key: 'price',
    render: () => (
      <Skeleton.Input
        size="small"
        style={{ width: '100px', alignItems: 'center' }}
      />
    ),
  },
];
